<template>
  <div>
    <!-- 商品类目 -->
    <el-dialog :title="goodsSel ? '店铺类目' : '商品类目'" :visible.sync="goodsCategoryDialog" width="500px" @close="handleDialogClose">
      <div><el-checkbox @change="allCheck"></el-checkbox> 全选</div>
      <div class="tree-box">
        <el-tree
          :data="list"
          show-checkbox
          default-expand-all
          node-key="id"
          ref="vuetree"
          highlight-current
          :props="defaultProps"
          :default-checked-keys="checkedClass"
          @check-change="handleCheckChange"
        ></el-tree>
      </div>
      <div class="classTotal">
        已添加 <span :style="{ color: globalBG }">{{ checkedList.length }}</span> 个类目
      </div>
      <div style="text-align:right" class="btn-group">
        <el-button @click="handleDialogClose">取消</el-button>
        <el-button @click="handleDialogSure" type="primary">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getSellercats } from "@/api/analysis/ware-controller";
import { mapState } from "vuex";
export default {
  name: "",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    goodsClass: {
      type: Array,
      default: () => [],
    },
    goodsSel: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      globalBG: "globalBG",
      //   把city映射给currentCIty
    }),
  },
  data() {
    return {
      goodsCategoryDialog: false,
      checkedClass: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      list: [],
      checkedList: [],
      allList: [],
    };
  },
  methods: {
    allCheck(val) {
      if (val) {
        let arr = this.allList.map((i) => i.id);
        this.$nextTick(function() {
          this.$refs.vuetree.setCheckedKeys(arr); //"treeList"是你自己在树形控件上设置的 ref="treeList" 的名称
        });
      } else {
        this.$refs.vuetree.setCheckedKeys([]); //"treeList"是你自己在树形控件上设置的 ref="treeList" 的名称
      }
    },
    handleDialogClose(value) {
      this.$emit("on-close", false);
    },
    handleDialogSure() {
      console.log(1111, this.list);
      let data = this.allList.filter((i) => i.isChecked);
      if (this.goodsSel) {
        let selectList = [...new Set(data.map((tag) => tag.parent_id))]; // 去重父ID
        // console.log(selectList, 666666);
        let quchong = [];
        let quchongER = [];
        this.list.forEach((item) => {
          item.children.forEach((item1) => {
            selectList.forEach((info) => {
              if (item1.id == info) {
                quchong.push(item1.parent_id);
              }
              if (item.id == info) {
                quchongER.push(item.parent_id);
              }
            });
          });
        });
        console.log(quchong, 666666, quchongER);

        // 选当择第一种类  和   第二种类时
        if (selectList.length > 0 && quchong.length == 0) {
          const dataPraent = [...new Set(data.map((tag) => tag.id))]; // id去重
          // console.log(dataPraent, 99999);
          let num = false;
          let num1 = false;
          selectList.forEach((item) => {
            if (item == 0) {
              num = true;
            } else {
              num1 = true;
            }
          });
          // console.log(num, num1, 9999);
          if (dataPraent.length > 1 && num1 == false) {
            return this.$message.warning("只能选择一个大类");
          } else if (dataPraent.length > 1 && num1 == true) {
            // 第二种类时
            // let siFirit = [...new Set(quchongER)]; //只能有一个大类
            if (selectList.length > 1) {
              return this.$message.warning("只能选择一个大类");
            }
            data = {
              id: selectList[0], // 父ID
              children: [...data],
              type: 2,
            };
          } else {
            // 当择第一种类
            // data = {
            //   id: data[0].id,
            //   children: [...data],
            //   type: 1,
            // };
            if (dataPraent[0] != selectList[0]) {
              data = {
                id: selectList[0],
                children: [...data],
                type: 2,
              };
            } else {
              // 当择第一种类
              data = {
                id: data[0].id,
                children: [...data],
                type: 1,
              };
            }
          }
          this.$emit("on-close", true, data);
          return;
        }
        // 当择第三种类
        let siFiritList = [...new Set(quchong)]; //只能有一个大类
        // console.log(siFiritList);
        let isflay = false;
        let warning = "";
        if (siFiritList.length > 1) {
          isflay = true;
          warning = "只能选择一个大类";
        }
        if (siFiritList.length == 0) {
          isflay = true;
          warning = "至少选择一个";
        }
        data = {
          id: siFiritList[0], // 只能有一个父iD
          children: [...data],
        };
        if (isflay) {
          return this.$message.warning(warning);
        }

        this.$emit("on-close", true, data);
      } else {
        this.$emit("on-close", true, data);
      }
    },
    transverter(data) {
      // 排重
      let obj = {};
      for (let i = 0; i < data.length; i++) {
        obj[data[i]["categoryId"]] = data[i];
      }
      let arr = Object.values(obj);
      // console.log(arr);
      var newData = [];
      for (var i = 0; i < arr.length; i++) {
        newData[i] = {
          id: arr[i].categoryId,
          parent_id: arr[i].parentId,
          name: arr[i].name,
          isChecked: false,
        };
      }

      return newData;
    },
    handleCheckChange(data, checked, indeterminate) {
      // console.log(data);
      if (checked) {
        // let index = this.allList.indexOf(data);
        const index = this.allList.findIndex((item) => item.id == data.id);
        // console.log(index);
        if (index != -1) {
          this.allList[index].isChecked = true;
        }
      } else {
        // let index = this.allList.indexOf(data.id);
        const index = this.allList.findIndex((item) => item.id == data.id);
        // this.allList[index].isChecked = false;
        if (index != -1) {
          this.allList[index].isChecked = false;
        }
      }
      this.checkedList = this.allList.filter((i) => i.isChecked);
    },
    getTrees(list, parent_id = 0) {
      let parentObj = {};
      list.forEach((o) => {
        parentObj[o.id] = o;
      });
      if (!parent_id) {
        return list.filter((o) => !parentObj[o.parent_id]).map((o) => ((o.children = this.getTrees(list, o.id)), o));
      } else {
        return list.filter((o) => o.parent_id == parent_id).map((o) => ((o.children = this.getTrees(list, o.id)), o));
      }
    },
  },
  mounted() {
    getSellercats().then((res) => {
      let data = this.transverter(res.data);
      this.getTrees(data);
      // console.log(data);
      this.list = data.filter((item) => item.parent_id == 0);
      // 所有的子节点
      this.allList = data.filter((item) => item.children.length == 0);
      // console.log(this.list, this.allList, 5555);
    });
  },
  watch: {
    value:{
      handler:function(value){
        this.goodsCategoryDialog = value;
        if (value == true) {
          // console.log(this.goodsClass);
          let arr = [];
          if (this.goodsClass.length != 0) {
            arr = this.goodsClass.map((i) => i.id);
          }
          // console.log(arr);
          this.$nextTick(function() {
            this.$refs.vuetree.setCheckedKeys(arr); //"treeList"是你自己在树形控件上设置的 ref="treeList" 的名称
          });
        }
      },
      immediate:true
    }
  },
};
</script>

<style lang="scss" scoped>
.classTotal {
  background: #f4f4f4;
  padding: 8px;
}
.tree-box {
  max-height: 300px;
  overflow: auto;
}
.btn-group {
  text-align: right;
  margin-top: 10px;
  .el-button {
    width: 96px;
  }
}
</style>
